import L from 'leaflet';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FullscreenControl = (L.Control as any).extend({
    _icon: HTMLElement,
    _buttonText: HTMLElement,

    includes: L.Evented.prototype,

    options: {
        buttonText: '<span class="leaflet-bar__heading">&nbsp;Fullskärm</span>',
        buttonExitText: '<span class="leaflet-bar__heading">&nbsp;Stäng fullskärm</span>',
    },

    onAdd(map: L.Map) {
        const container = L.DomUtil.create('div', 'fullscreen-bar leaflet-bar button button--map'),
            btn = L.DomUtil.create('a', 'fullscreen-button', container),
            text = L.DomUtil.create('span', '', btn),
            icon = L.DomUtil.create('span', '', btn);

        this._icon = icon;
        this._map = map;
        this._buttonText = text;
        btn.href = '#';
        this._updateContent();

        L.DomEvent.disableClickPropagation(btn);
        L.DomEvent.on(btn, 'click', L.DomEvent.stop);
        L.DomEvent.on(
            btn,
            'click',
            function () {
                if (this.isFullscreen()) {
                    this.disableFullscreen();
                    this.fire('disable');
                } else {
                    this.enableFullscreen();
                    this.fire('enable');
                }
            },
            this,
        );

        map.on('enablefullscreen', this.enableFullscreen, this);
        map.on('disablefullscreen', this.disableFullscreen, this);

        return container;
    },

    enableFullscreen() {
        this._updateContent();
    },

    disableFullscreen() {
        this._updateContent();
    },

    isFullscreen() {
        const mapContainer = this._map.getContainer();

        return mapContainer?.classList.contains('fullscreen');
    },

    _updateContent() {
        const isFullscreen = this.isFullscreen();
        this._buttonText.innerHTML = isFullscreen ? this.options.buttonExitText : this.options.buttonText;
        this._icon.setAttribute('class', isFullscreen ? 'icon-resize-small' : 'icon-resize-full');
    },
});
